import React, { useState } from "react";
import cancel from "../assets/images/navbar/cancel.png";

interface CouponListProps {
  onClose: () => void;
}

const CouponList = ({ onClose }: CouponListProps) => {
  const [copiedCode, setCopiedCode] = useState<string | null>(null);
  const [selectedCategories, setSelectedCategories] = React.useState<string>(
    "",
  );
  const offers = [
    {
      id: 1,
      code: "SAVE20",
      discount: "20% OFF",
      title: "Flat 20% Off on Total Bill",
      description: "Pay Bill via Duddu's to get flat 20% off on total bill",
      terms:
        "Only on Orders upto 2,000, for selected restaurants only, not valid for many seats, single booking only",
      bgColor: "bg-orange-500",
    },
    {
      id: 2,
      code: "FLAT20",
      discount: "20% OFF",
      title: "Flat 20% Discount",
      description: "Get flat 20% discount on your order",
      terms:
        "Valid on orders above ₹500, applicable once per user, not combinable with other offers",
      bgColor: "bg-orange-500",
    },
    {
      id: 3,
      code: "WELCOME",
      discount: "25% OFF",
      title: "Welcome Offer",
      description: "Enjoy 25% off on your first order with us",
      terms:
        "Valid for new users only, minimum order value ₹300, applicable on first order only",
      bgColor: "bg-orange-500",
    },
    {
      id: 4,
      code: "SAVE30",
      discount: "30% OFF",
      title: "Save Big Today",
      description: "Get 30% off on your order today",
      terms:
        "Valid on orders above ₹1000, applicable once per user, not combinable with other offers",
      bgColor: "bg-orange-500",
    },
    {
      id: 5,
      code: "FIRST50",
      discount: "50% OFF",
      title: "First Order Special",
      description: "Get 50% off on your first order with us",
      terms:
        "Valid for new users only, minimum order value ₹500, applicable on first order only",
      bgColor: "bg-orange-500",
    },
  ];
  const categories: string[] = ["All", "Bank Discount", "For you"];

    const toggleCategory = (category: string) => {
      setSelectedCategories((prev) => (prev === category ? "" : category));
    };

  const handleCopy = (code: string) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(null), 2000);
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-[1000] transition-opacity duration-300"
      onClick={onClose}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out rounded-l-[20px] shadow-[-23px_0_72px_0_rgba(0,0,0,0.15)] overflow-y-auto"
        style={{ animation: "slideInRight 0.3s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full inline-flex flex-col items-start rounded-l-[24px] bg-white shadow-[-23px_0_72px_0_rgba(0,0,0,0.15)] p-6">
          <div className="w-full">
            {/* Modal Header */}
            <div className="w-full flex justify-between items-center pb-[24px] border-b ">
              <p className="text-[#050505] font-Urbanist text-[20px] font-semibold leading-[140%]">
                Your Coupons
              </p>
              <img
                src={cancel}
                alt="close"
                onClick={onClose}
                className="flex w-[36px] h-[36px] p-[7.5px] justify-center items-center gap-[7.5px] shrink-0 rounded-full border-[0.75px] border-[rgba(112,107,102,0.25)] bg-[rgba(255,255,255,0.25)] cursor-pointer"
              />
            </div>

            <div className="flex flex-wrap gap-3 my-[16px]">
              {categories.map((item, index) => {
                const isSelected = selectedCategories.includes(item);
                return (
                  <button
                    key={index}
                    onClick={() => toggleCategory(item)}
                    className={`px-5 py-2 text-sm font-medium rounded-full border transition ${
                      isSelected
                        ? "bg-[#7604A5] text-white border-[#7604A5]"
                        : "border-gray-300 text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    {item}
                  </button>
                );
              })}
            </div>

            <div className="space-y-4">
              {offers.map((offer) => (
                <div
                  key={offer.id}
                  className="flex items-center max-w-2xl w-full mt-[12px]"
                >
                  {/* Left Orange Strip */}
                  <div
                    className={`${offer.bgColor} text-white w-[35px] h-[109px] rounded-l-2xl flex items-center justify-center`}
                  >
                    <p className="rotate-[-90deg] text-[14px] font-extrabold leading-[20px] whitespace-nowrap ">
                      {offer.discount}
                    </p>
                  </div>
                  <div className="flex-1 bg-gray-100 border border-gray-300 rounded-r-2xl px-[16px] py-[11px]  flex justify-between items-center">
                    {/* Text Content */}
                    <div>
                      <div className="border-b-2 border-dashed">
                        <h3 className="text-[#050505] text-left font-Urbanist text-[16px] font-medium leading-[20px]">
                          {offer.title}
                        </h3>
                        <p className="text-[#6A6A6A] text-left font-Urbanist text-[12px] font-normal leading-[17px]">
                          {offer.description}
                        </p>
                      </div>
                      <p className="text-[#6A6A6A] text-left font-Urbanist text-[11px] font-normal leading-[146%] mt-3 max-w-md">
                        {offer.terms}
                      </p>
                    </div>

                    <button className="text-purple-700 font-Urbanist text-[16px] font-semibold leading-[17px] -mt-[47px]">
                      APPLY
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponList;
